// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfg_a bhc_vc bhc_rm bhc_wf"};